import { Divider, Grid, Paper, Typography } from "@material-ui/core";
import React from "react";

import logo from "assets/imgs/comedy.jpg";
import icon from "assets/imgs/icon.png";

const quadroCard = () => {
  return (
    <Grid item xs={12} md={3} style={{ textAlign: "center" }}>
      <Paper elevation={3} style={{ padding: "10px" }}>
        <img
          src={logo}
          height="100px"
          width="100px"
          style={{ borderRadius: "1000px" }}
        />
        <Typography variant="h6">Loop Comedy</Typography>
        <Grid container alignItems="center" alignContent="center">
          <Grid item xs={6}>
            <Typography variant="body1">Nº Acessos</Typography>
            <Typography variant="h6">1245</Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography variant="body1">Nº Cliques</Typography>
            <Typography variant="h6">145 (10%)</Typography>
          </Grid>
        </Grid>
      </Paper>
    </Grid>
  );
};

export default function Dashboard() {
  return (
    <div>
      <Grid
        container
        alignItems="center"
        justifyContent="center"
        spacing={3}
        style={{ padding: "15px", textAlign: "center" }}
      >
        <Grid item xs={12} style={{ marginBottom: "15px" }}>
          <img src={icon} height="100px" />
          <Typography variant="h3">Dashboard</Typography>
          <Divider />
        </Grid>
        <Grid item xs={12} style={{ textAlign: "center" }}>
          <Typography variant="h5">Informações dos Quadros</Typography>
        </Grid>
        {quadroCard()}
        {quadroCard()}
        {quadroCard()}
        {quadroCard()}

        <Grid item xs={12}>
          <Divider />
        </Grid>
        <Grid item xs={12} style={{ textAlign: "center" }}>
          <Typography variant="h5">Top Anunciantes</Typography>
        </Grid>

        {quadroCard()}
        {quadroCard()}
        {quadroCard()}
        {quadroCard()}

        <Grid item xs={12}>
          <Divider />
        </Grid>
        <Grid item xs={12} style={{ textAlign: "center" }}>
          <Typography variant="h5">Top Produtos</Typography>
        </Grid>

        {quadroCard()}
        {quadroCard()}
        {quadroCard()}
        {quadroCard()}
      </Grid>
    </div>
  );
}
